import { useState, useEffect } from 'react';

const useCylinderSummary = () => {
  const [received, setReceived] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [filled, setFilled] = useState(0);
  const [dispatched, setDispatched] = useState(0);
  const [averiados, setAveriados] = useState(0); // ✅ NEW STATE
  const [contributions, setContributions] = useState([]);
  const [pendingToFillByClient, setPendingToFillByClient] = useState({});

  // /api/cylinders/summary is the source of truth for "remaining"/"dispatched"
  // per entry — it nets out both dispatches and devoluciones. The raw
  // /api/cylinders list has neither field (only `quantity` and a `dispatches[]`
  // array), so both refresh paths have to go through summary or they clobber
  // each other's state with incompatible shapes.
  const mapContributions = (data) =>
    Array.isArray(data.contributions)
      ? data.contributions.map(c => ({
          _id: c._id,
          client: c.client,
          amount: c.amount,
          type: c.type,
          // The despacho form groups stock by client and gas; CGC's own empties say who brought them.
          gas: c.gas || null,
          broughtBy: c.broughtBy || null,
          addedBy: c.addedBy,
          date: c.date,
          dispatched: c.dispatched || false,
          remaining: c.remaining || 0,
          // For the filler's "¿para qué pedido?" picker (cylinderAdder.js).
          ventasPedidoId: c.ventasPedidoId || null,
          ventasPedidoNumber: c.ventasPedidoNumber || null,
          ventasPedidoDate: c.ventasPedidoDate || null,
        }))
      : [];

  const refreshContributions = async () => {
    try {
      const res = await fetch('/api/cylinders/summary');
      const data = await res.json();
      setContributions(mapContributions(data));
      setPendingToFillByClient(data.pendingToFillByClient || {});
    } catch (err) {
      console.error('❌ Error refreshing contributions:', err);
    }
  };

  const fetchSummary = async () => {
    try {
      const res = await fetch('/api/cylinders/summary');
      const data = await res.json();
      setReceived(data.received || 0);
      setRemaining(data.remaining || 0);
      setFilled(data.filled || 0);
      setDispatched(data.dispatched || 0);
      setAveriados(data.averiados || 0); // ✅ SET AVERIADOS
      setContributions(mapContributions(data));
      setPendingToFillByClient(data.pendingToFillByClient || {});
    } catch (err) {
      console.error('❌ Error fetching summary:', err);
    }
  };

  useEffect(() => {
    fetchSummary();
    const interval = setInterval(fetchSummary, 10000); // refresh every 10s
    return () => clearInterval(interval);
  }, []);

  return {
    received,
    remaining,
    filled,
    dispatched,
    refreshContributions,
    averiados, // ✅ RETURN AVERIADOS
    contributions,
    pendingToFillByClient,
    refreshSummary: fetchSummary,
  };
};

export default useCylinderSummary;
